import React, { useContext } from 'react';

import {useUserContext} from "#app/contexts/useUserContext";

type MAIN_TYPE = ReturnType<typeof useUserContext>

const USER_CONTEXT_INSTANCE: React.Context<MAIN_TYPE | null> =
    React.createContext<MAIN_TYPE | null>(null);

/** @deprecated используйте useAppUserContext */
export const UserContext = USER_CONTEXT_INSTANCE;

export const UserContextProvider = USER_CONTEXT_INSTANCE.Provider;

export function useAppUserContext(): MAIN_TYPE {
    const value = useContext(USER_CONTEXT_INSTANCE);
    if (!value) {
        throw new Error("useAppUserContext must be used within UserContextProvider");
    }
    return value;
}

/** @deprecated используйте useAppUserContext */
export function useCustomUserContext<ContextValue>(
    Context: React.Context<ContextValue>
): ContextValue {
    return useContext(Context);
}

/** @deprecated используйте useAppUserContext */
export const customUseUserContext = useCustomUserContext;